import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useResolveDomainQuery } from '../../Api/Api';

/**
 * A custom domain may only present its own org's storefronts — the BFF enforces that server-side and
 * 404s every anonymous request for a foreign org, so a deep link like
 * https://customstore.mymsp.com/{someOtherOrg}/{theirStore}/login can never render another tenant's
 * store under this hostname. This hook is the UX half: instead of leaving the shopper on a dead error
 * page, bounce them to the domain's own storefront login. On platform hosts (and custom domains with
 * no default storefront) the resolve query 404s and nothing happens.
 */
export const useHostTenancyRedirect = (organization?: string) => {
    const nav = useNavigate();
    const resolved = useResolveDomainQuery(window.location.hostname);
    React.useEffect(() => {
        const home = resolved.data;
        if (!home?.organization || !home.storefront || !organization) return;
        if (home.organization.toLowerCase() === organization.toLowerCase()) return;
        nav(`/${home.organization}/${home.storefront}/login`, { replace: true });
    }, [resolved.data, organization, nav]);
};
